import NotificationInterface from "@app/Interface/NotificationInterface";
import NotificationModel from "@app/Model/NotificationModel";
import ApiEndpoints from "@app/utils/ApiEndpoints";
import RollbarHelper from "@app/utils/RollbarHelper";
import axios, { AxiosRequestConfig } from "axios";

export default class NotificationHelper {

    /**
     * Returns all the nofications for a logged in user. 
     * 
     * @param controller AbortController - handles if component unmounts or if cancel button is added
     * @returns 
     */
    static getNotifications = async (controller: AbortController): Promise<NotificationInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.NOTIFICATIONS + `?dismissed=false&notificationType=hc`;

        const url = baseUrl + endPoint;

        const options: AxiosRequestConfig<never> = {
            withCredentials: true,
            signal: controller.signal
        };

        try {

            const response = await axios.get(url, options)

            const dataItems: NotificationInterface[] = response.data["hydra:member"];

            const notifications: NotificationInterface[] = [];

            dataItems.forEach(item => {
               
                // this will make sure the datetime is converted from string to date object
                const notification = new NotificationModel(item);

                notifications.push(notification);
                
            });

            return notifications;

        } catch (error) {

            RollbarHelper.logRequestError(error, "getNotifications()");

            // return an empty set of navItems
            const emptyItems: Array<NotificationInterface> = [];

            return emptyItems;

        }

    }

    /**
     * Marks a notification as dismissed
     * NOTE: Function will not wait for response to dismissing the notification
     * 
     * @param notificationId 
     * @returns 
     */
    static dismissNotification = (notificationId: number): boolean => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.NOTIFICATIONS + `/${notificationId}`;

        const url = baseUrl + endPoint;

        const options = {
            withCredentials: true,
        };

        const today = new Date();

        const data = {
            dismissed: true,
            date: today.toISOString(),
        };

        try {

            axios.put(url, data, options)

            return true;

        } catch (error) {

            RollbarHelper.logRequestError(error, "dismissNotification()");

            return false;

        }

    }

}